import { useEffect } from 'react';
import { connect } from 'react-redux';
import prependLanguageToLink from 'shared/components/prepend-language-to-link';
var HardRedirect = function HardRedirect(_ref) {
  var siteLanguage = _ref.siteLanguage,
    to = _ref.to;
  useEffect(function () {
    window.location.assign(prependLanguageToLink(siteLanguage, to));
  }, []);
  return null;
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var application = _ref2.application;
  return {
    siteLanguage: application.siteLanguage
  };
};
export default connect(mapStateToProps)(HardRedirect);